import {
  CORE_DISRUPTION_NAME,
  CoreDisruptionComponent,
} from "@b2bportal/core-types";
import HowItWorksDialogStyles from "../HowItWorksDialog/styles.module.scss";
import DisruptionExerciseBulletPointStyles from "./DisruptionExerciseBulletPoint.module.scss";
import DisruptionExerciseButtonStyles from "./DisruptionExerciseButton.module.scss";
import DisruptionExerciseCheckboxStyles from "./DisruptionExerciseCheckbox.module.scss";
import DisruptionExerciseCheckedBagOptionsCardStyles from "./DisruptionExerciseCheckedBagOptionsCard.module.scss";
import DisruptionExerciseCheckoutComponentStyles from "./DisruptionExerciseCheckoutComponent.module.scss";
import DisruptionExerciseContainerStyles from "./DisruptionExerciseContainer.module.scss";
import DisruptionExerciseDateFilterStyles from "./DisruptionExerciseDateFilter.module.scss";
import DisruptionExerciseFlightCardStyles from "./DisruptionExerciseFlightCard.module.scss";
import DisruptionExerciseFlightCardFareListStyles from "./DisruptionExerciseFlightCardFareList.module.scss";
import DisruptionExerciseFlightInfoRowStyles from "./DisruptionExerciseFlightInfoRow.module.scss";
import DisruptionExerciseFooterStyles from "./DisruptionExerciseFooter.module.scss";
import DisruptionExerciseHeaderStyles from "./DisruptionExerciseHeader.module.scss";
import DisruptionExerciseInformationCardStyles from "./DisruptionExerciseInformationCard.module.scss";
import DisruptionExerciseLearnMoreContentStyles from "./DisruptionExerciseLearnMoreContent.module.scss";
import DisruptionExerciseLoadingStyles from "./DisruptionExerciseLoading.module.scss";
import DisruptionExerciseNoFlightsAvailableStyles from "./DisruptionExerciseNoFlightsAvailable.module.scss";
import DisruptionExerciseNotEligiblePageStyles from "./DisruptionExerciseNotEligiblePage.module.scss";
import DisruptionExercisePageStyles from "./DisruptionExercisePage.module.scss";
import DisruptionExercisePageContentStyles from "./DisruptionExercisePageContent.module.scss";
import DisruptionExercisePolicyDetailsStyles from "./DisruptionExercisePolicyDetails.module.scss";
import DisruptionExercisePopupStyles from "./DisruptionExercisePopup.module.scss";
import DisruptionExerciseRebookCheckoutPageStyles from "./DisruptionExerciseRebookCheckoutPage.module.scss";
import DisruptionExerciseRebookConfirmationPageStyles from "./DisruptionExerciseRebookConfirmationPage.module.scss";
import DisruptionExerciseRebookFlightShopPageStyles from "./DisruptionExerciseRebookFlightShopPage.module.scss";
import DisruptionExerciseRefundConfirmationPageStyles from "./DisruptionExerciseRefundConfirmationPage.module.scss";
import DisruptionExerciseRefundSummaryCardStyles from "./DisruptionExerciseRefundSummaryCard.module.scss";
import DisruptionExerciseSelectionStyles from "./DisruptionExerciseSelection.module.scss";
import DisruptionExerciseShopFilterStyles from "./DisruptionExerciseShopFilter.module.scss";
import DisruptionExerciseSummaryCardStyles from "./DisruptionExerciseSummaryCard.module.scss";
import DisruptionExerciseTimeWindowSliderStyles from "./DisruptionExerciseTimeWindowSlider.module.scss";
import DisruptionExpandableContainerStyles from "./DisruptionExpandableContainer.module.scss";
import DisruptionUniversalExerciseStyles from "./DisruptionUniversalExercise.module.scss";
import ExternalLinkContainerStyles from "./ExternalLinkContainer.module.scss";
import FlightDisruptionAlertBannerStyles from "./FlightDisruptionAlertBanner.module.scss";

export const CORE_DISRUPTION_STYLE_OVERRIDES = {
  [CORE_DISRUPTION_NAME]: {
    [CoreDisruptionComponent.DisruptionExpandableContainer]:
      DisruptionExpandableContainerStyles,
    [CoreDisruptionComponent.DisruptionExerciseBulletPoint]:
      DisruptionExerciseBulletPointStyles,
    [CoreDisruptionComponent.DisruptionExerciseCheckedBagOptionsCard]:
      DisruptionExerciseCheckedBagOptionsCardStyles,
    [CoreDisruptionComponent.DisruptionExerciseContainer]:
      DisruptionExerciseContainerStyles,
    [CoreDisruptionComponent.DisruptionExerciseSummaryCard]:
      DisruptionExerciseSummaryCardStyles,
    [CoreDisruptionComponent.DisruptionExerciseButton]:
      DisruptionExerciseButtonStyles,
    [CoreDisruptionComponent.DisruptionExerciseCheckoutComponent]:
      DisruptionExerciseCheckoutComponentStyles,
    [CoreDisruptionComponent.DisruptionExerciseFooter]:
      DisruptionExerciseFooterStyles,
    [CoreDisruptionComponent.DisruptionExerciseHeader]:
      DisruptionExerciseHeaderStyles,
    [CoreDisruptionComponent.DisruptionExerciseRefundSummaryCard]:
      DisruptionExerciseRefundSummaryCardStyles,
    [CoreDisruptionComponent.DisruptionExercisePageContent]:
      DisruptionExercisePageContentStyles,
    [CoreDisruptionComponent.DisruptionExerciseInformationCard]:
      DisruptionExerciseInformationCardStyles,
    [CoreDisruptionComponent.DisruptionExerciseDateFilter]:
      DisruptionExerciseDateFilterStyles,
    [CoreDisruptionComponent.DisruptionExercisePage]:
      DisruptionExercisePageStyles,
    [CoreDisruptionComponent.DisruptionExerciseFlightCard]:
      DisruptionExerciseFlightCardStyles,
    [CoreDisruptionComponent.DisruptionExerciseFlightCardFareList]:
      DisruptionExerciseFlightCardFareListStyles,
    [CoreDisruptionComponent.DisruptionExerciseRefundConfirmationPage]:
      DisruptionExerciseRefundConfirmationPageStyles,
    [CoreDisruptionComponent.DisruptionExerciseRebookCheckoutPage]:
      DisruptionExerciseRebookCheckoutPageStyles,
    [CoreDisruptionComponent.DisruptionExerciseRebookFlightShopPage]:
      DisruptionExerciseRebookFlightShopPageStyles,
    [CoreDisruptionComponent.DisruptionUniversalExercise]:
      DisruptionUniversalExerciseStyles,
    [CoreDisruptionComponent.DisruptionExerciseRebookConfirmationPage]:
      DisruptionExerciseRebookConfirmationPageStyles,
    [CoreDisruptionComponent.DisruptionExercisePopup]:
      DisruptionExercisePopupStyles,
    [CoreDisruptionComponent.DisruptionExerciseLearnMoreContent]:
      DisruptionExerciseLearnMoreContentStyles,
    [CoreDisruptionComponent.DisruptionExerciseLoading]:
      DisruptionExerciseLoadingStyles,
    [CoreDisruptionComponent.DisruptionExerciseNoFlightsAvailable]:
      DisruptionExerciseNoFlightsAvailableStyles,
    [CoreDisruptionComponent.DisruptionExerciseNotEligiblePage]:
      DisruptionExerciseNotEligiblePageStyles,
    [CoreDisruptionComponent.DisruptionExercisePolicyDetails]:
      DisruptionExercisePolicyDetailsStyles,
    [CoreDisruptionComponent.DisruptionExerciseFlightInfoRow]:
      DisruptionExerciseFlightInfoRowStyles,
    [CoreDisruptionComponent.DisruptionExerciseSelection]:
      DisruptionExerciseSelectionStyles,
    [CoreDisruptionComponent.DisruptionExerciseCheckbox]:
      DisruptionExerciseCheckboxStyles,
    [CoreDisruptionComponent.DisruptionExerciseTimeWindowSlider]:
      DisruptionExerciseTimeWindowSliderStyles,
    [CoreDisruptionComponent.DisruptionExerciseShopFilter]:
      DisruptionExerciseShopFilterStyles,
    [CoreDisruptionComponent.ExternalLinkContainer]:
      ExternalLinkContainerStyles,
    [CoreDisruptionComponent.HowItWorksDialog]: HowItWorksDialogStyles,
    [CoreDisruptionComponent.FlightDisruptionAlertBanner]:
      FlightDisruptionAlertBannerStyles,
  },
};
